'use strict';

import {mapValues} from "lodash";

import themes from "../../../../../common/data/themes";
import ProvidersStore from "../../../../../services/providers/ProvidersStore";

export default function(angularModule) {
  angularModule.controller('ReviewFormEditorCtrl', function(
    $scope, $state, pageInfo, $stateParams, reviewGenService, $log, stringService,
    updateService, accountsService, onComplete, imageManagerService, confirmService, isSharedDefault, user) {

    const THANK_YOU_TEMPLATE = "thankYouTemplate";

    let vm = this;
    vm.isFormDirty = true;
    vm.showVisibility = isSharedDefault || _.includes(user.permissions, 'ReviewBuilderVisibilityAdmin');

    vm.themes = themes;
    vm.mode = pageInfo.mode;
    vm.npsFlag = false;

    vm.accountConfig = {
      required : true,
      accountId : null,
      disableDropdown: vm.mode === "edit",
      showAccountSelection: false,
      editPage: true
    };

    vm.selectedTabType = "reviewForm"

    vm.selectedSampleForm = {
      id : vm.mode==="create" ? "default" : $stateParams.reviewFormId
    };

    vm.reviewProviders = ProvidersStore.reviewBuilderRevGenProviders;
    vm.selectedProviders = [];
    /**
     * Closes https://chatmeter.atlassian.net/browse/COFE-160
     * Our html template system is not really supporting versioning.
     * The flag helps us to determine providerLink dropdown html and display the dropdown when needed.
     */
    vm.hasProviderLinkDropdownHtml = false;

    vm.state = 'Loading';

    function initializeSelectedProviders(dynamicFields) {
      return Object.keys(dynamicFields).filter(x => x.startsWith("provider:")).map(x => x.split(":")[1].toUpperCase());
    }

    function findMissingFields(template) {
      let parser = new DOMParser()
      let doc = parser.parseFromString(template, "text/html")
      let missing = [];
      let ratingMissing = doc.getElementsByName("rating").length === 0
      let npsMissing = doc.getElementsByName("nps").length === 0
      if (ratingMissing && npsMissing) {
        missing.push('rating');
        missing.push('netPromoterScore');
      }
      if (doc.getElementsByName("reviewDetail").length === 0) missing.push('reviewDetail');

      return missing
    }

    function initReviewForm(form) {
      vm.state = "ReviewFormEditing";
      if (vm.mode === 'create') {
        delete form._id;
        form.isShared = isSharedDefault;
      }
      vm.reviewForm = form;
      vm.selectedProviders = initializeSelectedProviders(vm.reviewForm.dynamicFields);
      if (vm.reviewForm.accountId) {
        vm.accountConfig.accountId = vm.reviewForm.accountId;
      }

      if (form.theme) {
        vm.colorTheme = _.find(themes, {name: form.theme});
      }

      if ($stateParams.copy) {
        delete form._id
        vm.reviewForm.name = `Copy of ${vm.reviewForm.name}`
      }
    }

    vm.onEditorLoaded = function(editor) {
      editor.setTheme("ace/theme/chrome");
      editor.getSession().setMode("ace/mode/handlebars");
      editor.setShowPrintMargin(false);
      editor.$blockScrolling = Infinity;
      vm.editor = editor;
    };

    vm.pageStrings = stringService.adminStrings(vm.mode);

    function processSuccessfulAddReviewForm(response){
      vm.newReviewForm = response.data;
      let updateInfo = {
        status: "Active",
        type: "reviewForm",
        title: "Review Form",
        destinationRole: "manage",
        notificationType: "detail",
        actions: [{action: vm.mode}],
        entity: vm.newReviewForm,
        id: vm.newReviewForm._id,
        name: vm.newReviewForm.name,
        accountId: accountsService.getCurrentAccount(),
        searchParam: vm.newReviewForm.reviewFormname
      };
      updateService.registerSuccessfulUpdate(updateInfo,true);
      vm.state = 'Success';
      onComplete.resolve(vm.newReviewForm);
    }

    function handleError(response){
      let errorDetail = 'Please contact support';

      if(response.data && response.data.error.code) {
        let errorCode = response.data.error.code;

        if(errorCode === 'reviewForm.edit.reviewFormName.duplicate'){
          errorDetail = 'This Review Form name already exists. Review Form names must be unique.';
        }
      }

      vm.errorMsg = 'Error '+vm.pageStrings.errorAction+' Review Form!';
      vm.errorDetail = errorDetail;
      vm.state = 'ReviewFormEditing';
    }

    vm.onProvidersUpdated = ($item) => {
      if ($item && $item.id) {
        const provider = $item.id.toLowerCase();
        vm.selectedProviders.concat(provider);
        vm.reviewForm.dynamicFields[`provider:${provider}`] = provider;
      }
    };

    vm.onProvidersRemoved = ($item) => {
      if ($item && $item.id) {
        const provider = $item.id.toLowerCase();
        vm.selectedProviders = vm.selectedProviders.filter(x => x !== provider);
        delete vm.reviewForm.dynamicFields[`provider:${provider}`];
      }
    }

    vm.createEditReviewForm = function(isFormValid) {
      vm.formSubmitted = true;

      if(!isFormValid){
        $log.info('Missing Review Form data');
        return;
      }

      if (vm.npsFlag && !containsNpsField(vm.reviewForm)) {
        confirmService.confirm("Missing Net Promoter field", `
          You have removed the input field to collect Net Promoter scores - if you proceed, any campaigns
          which are collecting net promoter information will no longer be able to collect that data.
        `, confirmService.WARNING).then(agreed => {
          if (agreed) {
            vm.npsFlag = false;
            vm.createEditReviewForm(isFormValid);
          }
        })

        return;
      }

      let missingFields = findMissingFields(vm.reviewForm.template)
      if (missingFields.length > 0) {
        let message = `
            <p style="text-align:left">Are you sure you want to save this form?
              <br>The ${missingFields.map(f => `"${f}"`).join(' and ')} field${missingFields.length > 1 ? 's are' : ' is'} missing.<br>
              This will affect how reviews are displayed.
            </p>
        `;
        confirmService.confirm("Missing Fields", message, confirmService.WARNING)
          .then(agreed => {
            if (agreed) {
              vm.saveForm();
            }
          })
      } else {
        vm.saveForm();
      }
    };

    vm.saveForm = function() {
      vm.state = 'PendingConfirmation';
      let preppedForm = {}
      angular.copy(vm.reviewForm, preppedForm);
      preppedForm.dynamicFields = dynamicFieldValuesToStrings(vm.reviewForm.dynamicFields);

      if (vm.mode === "create" || $stateParams.copy) {
        reviewGenService.addReviewForm(preppedForm).then(processSuccessfulAddReviewForm).catch(handleError);
      } else {
        reviewGenService.updateReviewForm(preppedForm).then(processSuccessfulAddReviewForm).catch(handleError);
      }
    }

    vm.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (!input.$pristine || vm.formSubmitted);
    };

    const dynamicFieldValuesToStrings = (dynamicFields) => {
      return mapValues(dynamicFields,(value, key, object) => {
       return value.toString()
      })
    }

    activate();

    function activate() {
      vm.state = 'Loading';
      vm.formSubmitted = false;
      if(vm.mode === "create"){
        vm.accountConfig.accountId = accountsService.getCurrentAccount();
      }

      if ($stateParams.reviewForm) {
        initReviewForm(angular.copy($stateParams.reviewForm));
        if (containsNpsField($stateParams.reviewForm)) {
          vm.npsFlag = true;
        }
      } else {
        reviewGenService.getReviewForm(vm.selectedSampleForm.id).then(function(response) {
          initReviewForm(response.data);
        })
      }
    }

    let lastSelected = null;

    vm.previewForm = _.debounce(previewForm, 400);

    function previewForm(type) {
      type = type || lastSelected;
      vm.selectedTabType = type;
      lastSelected = type;
      vm.isFormDirty = true;
      recalculateDynamicFields(type);

      let preppedForm = {}
      angular.copy(vm.reviewForm, preppedForm);
      preppedForm.dynamicFields = dynamicFieldValuesToStrings(vm.reviewForm.dynamicFields);

      reviewGenService.previewAlertTemplate(preppedForm).then(function(response) {
        vm.isFormDirty = false;
        let template = "";
        let iframeId = "";
        if(type==="reviewForm"){
          template = response.data.form;
          iframeId = "#previewForm";
        }
        else if (type === THANK_YOU_TEMPLATE) {
          template = response.data.thankYou;
          if(template.includes("<footer class=\"footer p-0 m-0\"")){
            vm.hasProviderLinkDropdownHtml = true;
          }
          iframeId = "#previewThankYouPage";
        }

        // redraw iframe
        let iframe = $(iframeId)[0]
        let iframedoc = iframe.contentDocument || iframe.contentWindow.document;
        iframedoc.open();
        iframedoc.write(template);
        iframedoc.close();
      });
    }

    vm.isThankYouTemplate = () => {
      return vm.selectedTabType === THANK_YOU_TEMPLATE;
    };

    vm.triggerEditorRefresh = function(type, template){
      if(template){
        vm.editor.setValue(template);
      }
      vm.selectedTabType = type;
      recalculateDynamicFields(type)
    };

    function recalculateDynamicFields(type) {
      if (!vm.reviewForm) {
        return;
      }
      vm.dynamicFields = [];
      let dynamicFieldRegex = /{{\s*dynamicField:([^ }]+)\s*}}/g, result;
      let content;
      if(type === "reviewForm") {
        content = vm.reviewForm.template
      }
      if (type === THANK_YOU_TEMPLATE) {
        content = vm.reviewForm.thankYouTemplate
      }
      while (result = dynamicFieldRegex.exec(content)) {
        imgResult = null;
        textResult = null;
        toggleResult = null;
        providerResult = null;
        var imageUploadRegex = /image:([^ }]+)/g, imgResult;
        var textRegex = /text:([^ }]+)/g, textResult;
        var toggleRegex = /toggle:([^ }]+)/g, toggleResult;
        var providerRegex = /provider:([^ }]+)/g, providerResult;
        imgResult = imageUploadRegex.exec(result[1]);
        textResult = textRegex.exec(result[1]);
        toggleResult = toggleRegex.exec(result[1]);
        providerResult = providerRegex.exec(result[1]);

        if (imgResult !== null && notAlreadyAdded("image:", imgResult[1])) {
          vm.dynamicFields.push(["image:", imgResult[1]])
          initializeImageNames("image:" + imgResult[1])
        }
        else if (textResult !== null && notAlreadyAdded("text:", textResult[1]))  {
          vm.dynamicFields.push(["text:", textResult[1]]);
        }
        else if( toggleResult !== null && notAlreadyAdded("toggle:", toggleResult[1])) {
          vm.dynamicFields.push(["toggle:", toggleResult[1]])
          let maybeExistingField = vm.reviewForm.dynamicFields[toggleResult[0]]
          vm.reviewForm.dynamicFields[toggleResult[0]] = maybeExistingField ?  (maybeExistingField === 'true' || maybeExistingField === true) : false
        } else if (providerResult !== null && notAlreadyAdded("provider:", providerResult[1])) {
          vm.dynamicFields.push(["provider:", providerResult[1]]);
        }
      }
    }

    function notAlreadyAdded(key,value) {
      return !vm.dynamicFields.find(fieldObj => (fieldObj[0]===key && fieldObj[1]===value))
    }

      function initializeImageNames(fieldName) {
        imageManagerService.listImages().then(images => {
          vm.imageArray[fieldName] = _.findWhere(images, {url: vm.reviewForm.dynamicFields[fieldName]})
        })
      }

    vm.imageSelected = function(fieldName) {
      return function(image) {
        vm.reviewForm.dynamicFields[fieldName] = image.url;
        vm.imageArray[fieldName] = image
        vm.previewForm(vm.selectedTabType)
      }
    }

    vm.deselectImage = function(field){
      vm.imageArray[field[0] + field[1]] = null;
      vm.reviewForm.dynamicFields[field[0]+field[1]] = "";
      vm.previewForm(vm.selectedTabType)
    }

    vm.imageArray = {};

    $scope.$watch("vm.reviewForm.template", function(newVal, oldVal) {
      recalculateDynamicFields("reviewForm");
      if (newVal !== oldVal) {
        vm.isFormDirty = true;
      }
    });

    $scope.$watch("vm.reviewForm.dynamicFields",(newVal,oldVal) => {
      if(newVal !== oldVal){
        vm.previewForm(vm.selectedTabType)
      }
    },1)

    $scope.$watch("vm.reviewForm.thankYouTemplate", function(newVal, oldVal) {
      recalculateDynamicFields("thankYouTemplate");
      if (newVal !== oldVal) {
        vm.isFormDirty = true;
      }
    });

    $scope.$watch('vm.accountConfig.accountId',function(newVal,oldVal){
      if(newVal !== oldVal) {
        vm.reviewForm.accountId = newVal;
      }
    });

    vm.pushCssConfig = function() {

      let injectStyle = (htmlContent) => {

        // we do funky regex and string appending here because we can't dom parse the html contents
        // due to handlebars expressions within tags

        // capture the original head part of HTML
        let regex = /<head>(.|[\r\n])*<\/head>/;
        let foundMatches = htmlContent.match(regex);
        let originalHead = foundMatches[0];
        let index = htmlContent.indexOf(originalHead);

        // create document out of head and inject styles
        let headDoc = new DOMParser().parseFromString(originalHead, 'text/html');
        let styleNode = headDoc.querySelector('#injected-style') || headDoc.createElement("style");
        styleNode.id = "injected-style";
        styleNode.type = 'text/css';
        if (styleNode.styleSheet){
          styleNode.styleSheet.cssText = vm.colorTheme.style;
        } else {
          styleNode.innerHTML = vm.colorTheme.style;
        }
        headDoc.body.id = "templateBody";       // Strengthen the selectors to override existing rules
        headDoc.head.appendChild(styleNode);

        // splice together the new html contents
        return  htmlContent.slice(0,index) +
          "<head>" + headDoc.head.innerHTML +
          "</head>" + htmlContent.slice(index +
            originalHead.length, htmlContent.length);
      };

      vm.reviewForm.template = injectStyle(vm.reviewForm.template);
      vm.reviewForm.thankYouTemplate = injectStyle(vm.reviewForm.thankYouTemplate);

      vm.isFormDirty = true;
      vm.previewForm();
    }

  });

  function containsNpsField(form) {
    let formDoc = new DOMParser().parseFromString(form.template, 'text/html');
    return formDoc.getElementsByName("nps").length !== 0;
  }
};
